import {
  SCAN_START,
  SCAN_SUCCESS,
  SCAN_FAILURE,
  SCAN_RESET,
} from '../actions/scanActions';

// step : 'landing' | 'scanning' | 'verdict'
const initialState = {
  step: 'landing',
  loading: false,
  steamId: null,
  verdict: null,
  error: null,
};

export default function scanReducer(state = initialState, action) {
  switch (action.type) {
    case SCAN_START:
      return {
        ...state,
        step: 'scanning',
        loading: true,
        steamId: action.payload.steamId,
        verdict: null,
        error: null,
      };
    case SCAN_SUCCESS:
      return { ...state, step: 'verdict', loading: false, verdict: action.payload };
    case SCAN_FAILURE:
      return { ...state, step: 'landing', loading: false, error: action.payload };
    case SCAN_RESET:
      return initialState;
    default:
      return state;
  }
}
